import { CssStates, embeddedImagesBase64, IGrapesJSProjectData } from "../../../interfaces/VisageUI";

const GjsTemplateImageMenu: IGrapesJSProjectData = {
	"assets":[

	],
	"styles":[
		{
			"selectors":[

			],
			"selectorsAdd":"body",
			"style":{
				"width":"100vw",
				"height":"100vh",
				"background-color":"transparent"
			}
		},
		{
			"selectors":[
				"gjs-plh-image"
			],
			"style":{
				"background-image":"none",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"outline-color":"initial",
				"outline-style":"none",
				"outline-width":"initial"
			}
		},
		{
			"selectors":[
				"#Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616"
			],
			"style":{
				"width":"100%",
				"height":"100%",
				"display":"flex",
				"align-content":"center",
				"flex-direction":"column",
				"justify-content":"center",
				"align-items":"center"
			}
		},
		{
			"selectors":[
				"Btn_SecondaryCTA"
			],
			"style":{
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #b4b4b4 86%, #d5d5d5 100%)",
				"position":"relative",
				"margin":"0vw 0.5vw 0vw 0vw",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				"Btn_Primary_CTA"
			],
			"style":{
				"position":"relative",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				{
					"name":"Btn_SecondaryTest",
					"active":false
				}
			],
			"style":{
				"width":"20vw",
				"border":"0vw none black"
			}
		},
		{
			"selectors":[
				"#C0df669d1-6c9d-4ed3-a74b-fe9f5f083d58"
			],
			"style":{
				"width":"20vw",
				"flex-direction":"column",
				"position":"relative",
				"display":"flex",
				"height":"auto",
				"background":"rgba(30, 30, 30, 0)",
				"margin-left":"1vw",
				"margin-right":"1vw",
				"margin-top":"1vw",
				"margin-bottom":"1vw"
			}
		},
		{
			"selectors":[
				"#C57d01a5f-984b-4018-b8bc-6ef8d1d68f27"
			],
			"style":{
				"flex-direction":"column",
				"width":"100%",
				"height":"24vw",
				"justify-content":"center",
				"align-items":"center",
				"display":"flex",
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #373737 0%, #4f4f4f 100%)",
				"box-shadow":"0 0 2vw 0 rgba(0,0,0,0.4) ",
				"border-top-left-radius":"1vw",
				"border-top-right-radius":"1vw",
				"border-bottom-right-radius":"1vw",
				"border-bottom-left-radius":"1vw",
				"padding-top":"2vw",
				"padding-bottom":"2vw",
				"padding-left":"2vw",
				"padding-right":"2vw"
			}
		},
		{
			"selectors":[
				"#Ce302b1c5-a005-4b71-a27a-7948bc4725f1"
			],
			"style":{
				"flex-direction":"row",
				"width":"100%",
				"align-content":"center",
				"justify-content":"center",
				"text-align":"center",
				"align-items":"flex-start",
				"margin-top":"0vw",
				"margin-bottom":"0vw",
				"margin-left":"0vw",
				"margin-right":"0vw",
				"display":"flex",
				"flex-wrap":"wrap"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"*",
			"style":{
				"font-family":"Roboto, Arial, sans-serif"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar",
			"style":{
				"width":"10px",
				"height":"10px"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-track",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-corner",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb",
			"style":{
				"background-color":"rgb(191, 191, 191)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb:hover",
			"style":{
				"background-color":"rgb(235, 235, 235)"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(118, 118, 118) 0%, rgb(79, 79, 79) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(235, 235, 235)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(164, 164, 164) 0%, rgb(126, 126, 126) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"9vw",
				"height":"9vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"7.25vw",
				"height":"7.25vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[

			],
			"selectorsAdd":"div[data-gjs-type=\"wrapper\"]",
			"style":{
				"height":"100vh",
				"width":"100vw"
			}
		},
		{
			"selectors":[
				"#C52b12ee6-578b-478e-984c-00781bc5220a-2"
			],
			"style":{
				"width":"100%",
				"height":"auto",
				"font-size":"2vw",
				"font-weight":"normal",
				"color":"rgba(235, 235, 235, 1)",
				"text-align":"left"
			}
		},
		{
			"selectors":[
				"visageEditorDefaultContainer"
			],
			"style":{
				"position":"relative",
				"width":"100%",
				"height":"100%",
				"display":"flex",
				"align-items":"center",
				"justify-content":"center"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"text",
			"style":{
				"display":"inline-block",
				"min-width":"1vw",
				"min-height":"1vw"
			}
		},
		{
			"selectors":[
				"#C728800c3-c7fd-4632-ae78-de060950615b"
			],
			"style":{
				"position":"absolute",
				"right":"1.5vw",
				"top":"calc(50% + 0vw)",
				"transform":"translateY(-50%)",
				"display":"flex",
				"align-items":"center",
				"flex-direction":"column",
				"justify-content":"center"
			}
		},
		{
			"selectors":[
				"#Cc5deffa8-e119-4dc1-bf0e-5602ec6726c2"
			],
			"style":{
				"position":"relative",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"4.5vw",
				"border-top-right-radius":"4.5vw",
				"border-bottom-right-radius":"4.5vw",
				"border-bottom-left-radius":"4.5vw",
				"width":"9vw",
				"height":"9vw",
				"padding-left":"0.5vw",
				"margin-top":"0vw",
				"margin-bottom":"1vw",
				"margin-left":"0vw",
				"margin-right":"0vw",
				"padding-top":"1.5vw",
				"padding-bottom":"1.5vw"
			}
		},
		{
			"selectors":[
				"#C728244c0-21fa-4c2c-a1b7-1efd3782f698"
			],
			"style":{
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#C3e29e481-c27b-4df5-8bd5-17fec688f4cb"
			],
			"style":{
				"position":"relative",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"3.625vw",
				"border-top-right-radius":"3.625vw",
				"border-bottom-right-radius":"3.625vw",
				"border-bottom-left-radius":"3.625vw",
				"width":"7.25vw",
				"height":"7.25vw",
				"padding-right":"0.5vw",
				"padding-top":"1.25vw",
				"padding-bottom":"1.25vw"
			}
		},
		{
			"selectors":[
				"#C84b4f263-7c09-4b94-9421-87c5eeb78302"
			],
			"style":{
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#C777db716-dc93-4ae3-8599-3073f29fd221"
			],
			"style":{
				"position":"absolute",
				"bottom":"2vw",
				"left":"2vw",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"3.625vw",
				"border-top-right-radius":"3.625vw",
				"border-bottom-right-radius":"3.625vw",
				"border-bottom-left-radius":"3.625vw",
				"display":"flex",
				"padding-bottom":"0.5vw"
			}
		},
		{
			"selectors":[
				"#C4ea1aa44-50fd-4bcc-8856-e6e4a4b7d2ce"
			],
			"style":{
				"width":"70%",
				"height":"70%"
			}
		},
		{
			"selectors":[
				"#C3046af51-c962-4645-af7a-7d2ec8d5ab06"
			],
			"style":{
				"width":"100%",
				"height":"auto",
				"font-size":"2vw",
				"font-weight":"normal",
				"color":"rgba(235, 235, 235, 1)",
				"text-align":"left"
			}
		},
		{
			"selectors":[
				"#C8586c2c0-f96a-4eeb-bfdd-6ccc67824c27"
			],
			"style":{
				"flex-direction":"column",
				"width":"100%",
				"height":"24vw",
				"justify-content":"center",
				"align-items":"center",
				"display":"flex",
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #373737 0%, #4f4f4f 100%)",
				"box-shadow":"0 0 2vw 0 rgba(0,0,0,0.4) ",
				"border-top-left-radius":"1vw",
				"border-top-right-radius":"1vw",
				"border-bottom-right-radius":"1vw",
				"border-bottom-left-radius":"1vw",
				"padding-top":"2vw",
				"padding-bottom":"2vw",
				"padding-left":"2vw",
				"padding-right":"2vw"
			}
		},
		{
			"selectors":[
				"#C8586c2c0-f96a-4eeb-bfdd-6ccc67824c27-3"
			],
			"style":{
				"width":"20vw",
				"flex-direction":"column",
				"position":"relative",
				"display":"flex",
				"height":"auto",
				"background":"rgba(30, 30, 30, 0)",
				"margin-left":"1vw",
				"margin-right":"1vw",
				"margin-top":"1vw",
				"margin-bottom":"1vw"
			}
		},
		{
			"selectors":[
				"#Cf62ffc17-27ba-4a8d-afe3-4cab3602b6ae"
			],
			"style":{
				"width":"100%",
				"height":"auto",
				"font-size":"2vw",
				"font-weight":"normal",
				"color":"rgba(235, 235, 235, 1)",
				"text-align":"left"
			}
		},
		{
			"selectors":[
				"#C59b5e03e-592b-479b-9156-d7af61a011be"
			],
			"style":{
				"flex-direction":"column",
				"width":"100%",
				"height":"24vw",
				"justify-content":"center",
				"align-items":"center",
				"display":"flex",
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #373737 0%, #4f4f4f 100%)",
				"box-shadow":"0 0 2vw 0 rgba(0,0,0,0.4) ",
				"border-top-left-radius":"1vw",
				"border-top-right-radius":"1vw",
				"border-bottom-right-radius":"1vw",
				"border-bottom-left-radius":"1vw",
				"padding-top":"2vw",
				"padding-bottom":"2vw",
				"padding-left":"2vw",
				"padding-right":"2vw"
			}
		},
		{
			"selectors":[
				"#C59b5e03e-592b-479b-9156-d7af61a011be-3"
			],
			"style":{
				"width":"20vw",
				"flex-direction":"column",
				"position":"relative",
				"display":"flex",
				"height":"auto",
				"background":"rgba(30, 30, 30, 0)",
				"margin-left":"1vw",
				"margin-right":"1vw",
				"margin-top":"1vw",
				"margin-bottom":"1vw"
			}
		},
		{
			"selectors":[
				"#C6a42d0ab-9706-4269-a3b4-6f70ee9249e5"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"1vw",
				"margin-bottom":"0vw",
				"margin-left":"0vw",
				"margin-right":"0vw"
			}
		},
		{
			"selectors":[
				"#C96f2e466-46ea-4c1c-b13f-ff8e4677aa5d"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)",
				"text-align":"center"
			}
		},
		{
			"selectors":[
				"#Cce36cb3f-0529-4beb-a71c-5b8fbaee2ef5"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"1vw",
				"margin-bottom":"0vw",
				"margin-left":"0vw",
				"margin-right":"0vw"
			}
		},
		{
			"selectors":[
				"#Cd5b771cd-09c1-4adc-a6ca-4ae4e0dc359b"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)",
				"text-align":"center"
			}
		},
		{
			"selectors":[
				"#C8186b8b5-20c1-48ff-9f26-20da7c3a4834"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"1vw",
				"margin-bottom":"0vw",
				"margin-left":"0vw",
				"margin-right":"0vw"
			}
		},
		{
			"selectors":[
				"#C6d9b6d57-9e3b-4b18-86f1-a4472fe54fb9"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)",
				"text-align":"center"
			}
		},
		{
			"selectors":[
				"#C6e6e8039-f883-4ddd-8d28-f27791b7fa0d"
			],
			"style":{
				"display":"flex",
				"flex-direction":"column",
				"justify-content":"flex-start",
				"align-items":"center",
				"position":"relative",
				"padding-left":"1.5vw",
				"padding-top":"1.5vw",
				"padding-right":"1.5vw",
				"padding-bottom":"1.5vw",
				"margin-top":"2vw",
				"margin-bottom":"0vw",
				"margin-left":"0vw",
				"margin-right":"0vw",
				"width":"100%",
				"overflow-x":"hidden",
				"overflow-y":"auto",
				"max-width":"70vw"
			}
		},
		{
			"selectors":[
				"#C777546c2-f187-4a72-b444-0b9a7089436b"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"2.5vw",
				"font-weight":"400",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)",
				"position":"relative",
				"margin-top":"1vw",
				"margin-bottom":"1vw",
				"margin-left":"0vw",
				"margin-right":"0vw"
			}
		},
		{
			"selectors":[
				"#C8dcad8a4-8f79-4991-9b44-0d53db4b8354"
			],
			"style":{
				"display":"flex",
				"flex-direction":"row",
				"justify-content":"center",
				"align-items":"center",
				"position":"absolute",
				"width":"18vw",
				"height":"3vw",
				"background":"rgba(48, 48, 48, 0.8)",
				"padding-left":"1.5vw",
				"padding-top":"1.5vw",
				"padding-right":"1.5vw",
				"padding-bottom":"1.5vw",
				"border-top-left-radius":"0.5vw",
				"border-top-right-radius":"0.5vw",
				"border-bottom-right-radius":"0.5vw",
				"border-bottom-left-radius":"0.5vw",
				"top":"1vw",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#C8bd5df87-7e53-44d7-a281-010c72af241c"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"1.5vw",
				"font-weight":"normal",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"#C7ba68e1f-ff88-42d0-8b47-3dbf32f70bd9"
			],
			"style":{
				"display":"flex",
				"flex-direction":"row",
				"justify-content":"center",
				"align-items":"center",
				"position":"absolute",
				"width":"18vw",
				"height":"3vw",
				"background":"rgba(48, 48, 48, 0.8)",
				"padding-left":"1.5vw",
				"padding-top":"1.5vw",
				"padding-right":"1.5vw",
				"padding-bottom":"1.5vw",
				"border-top-left-radius":"0.5vw",
				"border-top-right-radius":"0.5vw",
				"border-bottom-right-radius":"0.5vw",
				"border-bottom-left-radius":"0.5vw",
				"top":"1vw",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#C50faeae9-e036-4db2-8fdf-1d8744eaee7d"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"1.5vw",
				"font-weight":"normal",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"#C7f9f2d63-f8b6-4c17-9dd1-96689bfbbd86"
			],
			"style":{
				"display":"flex",
				"flex-direction":"row",
				"justify-content":"center",
				"align-items":"center",
				"position":"absolute",
				"width":"18vw",
				"height":"3vw",
				"background":"rgba(48, 48, 48, 0.8)",
				"padding-left":"1.5vw",
				"padding-top":"1.5vw",
				"padding-right":"1.5vw",
				"padding-bottom":"1.5vw",
				"border-top-left-radius":"0.5vw",
				"border-top-right-radius":"0.5vw",
				"border-bottom-right-radius":"0.5vw",
				"border-bottom-left-radius":"0.5vw",
				"top":"1vw",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#C6fbe0bdf-9890-4da7-ba6f-fc87c3fb8a19"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"1.5vw",
				"font-weight":"normal",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"#C4a17b8da-6106-4a57-99bf-0940467cd417"
			],
			"style":{
				"justify-content":"center",
				"align-items":"center",
				"width":"100%",
				"height":"6vw",
				"position":"absolute",
				"display":"none",
				"background":"rgba(30, 30, 30, 0.9)",
				"flex-direction":"row",
				"top":"0vw",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#Cb470cdf2-6dbf-4884-8d38-d8269c3f2b6f"
			],
			"style":{
				"width":"auto",
				"height":"70%",
				"font-size":"2vw",
				"font-weight":"normal",
				"color":"#EBEBEB",
				"text-align":"left"
			}
		},
		{
			"selectors":[
				"#Cca2dbc2b-39ea-4c9d-83ab-c5a44146aed6"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"2.5vw",
				"font-weight":"700",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)",
				"margin-top":"0vw",
				"margin-bottom":"0vw",
				"margin-left":"1vw",
				"margin-right":"0vw"
			}
		}
	],
	"pages":[
		{
			"frames":[
				{
					"component":{
						"type":"wrapper",
						"stylable":[
							"background",
							"background",
							"background-image",
							"background-repeat",
							"background-attachment",
							"background-position",
							"background-size"
						],
						"attributes":{
							"id":"i5rl"
						},
						"components":[
							{
								"type":"div",
								"attributes":{
									"id":"Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616",
									"data-action":"",
									"data-no-actions":"",
									"data-not-deletable":"",
									"data-not-resizable":"",
									"data-not-copiable":""
								},
								"components":[
									{
										"type":"div",
										"name":"Container",
										"attributes":{
											"id":"C4a17b8da-6106-4a57-99bf-0940467cd417",
											"data-action":""
										},
										"components":[
											{
												"type":"image",
												"name":"Image",
												"resizable":{
													"ratioDefault":1
												},
												"attributes":{
													"id":"Cb470cdf2-6dbf-4884-8d38-d8269c3f2b6f",
													"asset-id":"",
													"src":embeddedImagesBase64.scopeCube,
												}
											},
											{
												"type":"e-text",
												"name":"Text",
												"content":"Title",
												"attributes":{
													"id":"Cca2dbc2b-39ea-4c9d-83ab-c5a44146aed6",
												}
											}
										],
										"custom-name":"Banner",
										"__prev-display":"flex"
									},
									{
										"type":"div",
										"attributes":{
											"id":"C728800c3-c7fd-4632-ae78-de060950615b",
											"data-action":""
										},
										"components":[
											{
												"type":"div",
												"name":"Next Button",
												"classes":[
													"primary-icon-cta"
												],
												"attributes":{
													"id":"Cc5deffa8-e119-4dc1-bf0e-5602ec6726c2",
													"data-action":"next_step"
												},
												"components":[
													{
														"type":"image",
														"name":"Icon",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"C728244c0-21fa-4c2c-a1b7-1efd3782f698",
															"asset-id":"",
															"src":embeddedImagesBase64.next,
														}
													}
												]
											},
											{
												"type":"div",
												"name":"Previous Button",
												"classes":[
													"secondary-icon-cta"
												],
												"attributes":{
													"id":"C3e29e481-c27b-4df5-8bd5-17fec688f4cb",
													"data-action":"previous_step"
												},
												"components":[
													{
														"type":"image",
														"name":"Icon",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"C84b4f263-7c09-4b94-9421-87c5eeb78302",
															"asset-id":"",
															"src":embeddedImagesBase64.prev,
														}
													}
												]
											}
										],
										"custom-name":"Prev/Next Buttons",
										"__prev-display":"flex"
									},
									{
										"type":"div",
										"name":"Empty Container",
										"attributes":{
											"id":"C6e6e8039-f883-4ddd-8d28-f27791b7fa0d",
										},
										"components":[
											{
												"type":"e-text",
												"name":"Text",
												"content":"Select an option from below",
												"attributes":{
													"id":"C777546c2-f187-4a72-b444-0b9a7089436b",
												},
												"custom-name":"Description"
											},
											{
												"type":"div",
												"attributes":{
													"id":"Ce302b1c5-a005-4b71-a27a-7948bc4725f1",
													"data-action":""
												},
												"components":[
													{
														"type":"div",
														"attributes":{
															"id":"C0df669d1-6c9d-4ed3-a74b-fe9f5f083d58",
															"data-action":""
														},
														"components":[
															{
																"type":"div",
																"attributes":{
																	"id":"C57d01a5f-984b-4018-b8bc-6ef8d1d68f27",
																	"data-action":""
																},
																"components":[
																	{
																		"type":"div",
																		"name":"Background",
																		"attributes":{
																			"id":"C8dcad8a4-8f79-4991-9b44-0d53db4b8354",
																		},
																		"components":[
																			{
																				"type":"e-text",
																				"name":"Text",
																				"content":"Header",
																				"attributes":{
																					"id":"C8bd5df87-7e53-44d7-a281-010c72af241c",
																				}
																			}
																		],
																		"custom-name":"Title"
																	},
																	{
																		"type":"image",
																		"name":"Image",
																		"resizable":{
																			"ratioDefault":1
																		},
																		"attributes":{
																			"id":"C52b12ee6-578b-478e-984c-00781bc5220a-2",
																			"asset-id":"",
																			"src":embeddedImagesBase64.imagePlaceholder,
																		}
																	}
																],
																"custom-name":"Main Card"
															},
															{
																"type":"div",
																"name":"Primary Button",
																"classes":[
																	"primary-cta"
																],
																"attributes":{
																	"id":"C6a42d0ab-9706-4269-a3b4-6f70ee9249e5",
																	"asset-id":""
																},
																"components":[
																	{
																		"type":"e-text",
																		"name":"Label",
																		"content":"Select",
																		"attributes":{
																			"id":"C96f2e466-46ea-4c1c-b13f-ff8e4677aa5d",
																		}
																	}
																],
																"custom-name":"Select Button"
															}
														],
														"custom-name":"Gallery Card 1"
													},
													{
														"type":"div",
														"attributes":{
															"id":"C8586c2c0-f96a-4eeb-bfdd-6ccc67824c27-3",
															"data-action":""
														},
														"components":[
															{
																"type":"div",
																"attributes":{
																	"id":"C8586c2c0-f96a-4eeb-bfdd-6ccc67824c27",
																	"data-action":""
																},
																"components":[
																	{
																		"type":"image",
																		"name":"Image",
																		"resizable":{
																			"ratioDefault":1
																		},
																		"attributes":{
																			"id":"C3046af51-c962-4645-af7a-7d2ec8d5ab06",
																			"asset-id":"",
																			"src":embeddedImagesBase64.imagePlaceholder,
																		}
																	},
																	{
																		"type":"div",
																		"name":"Background",
																		"attributes":{
																			"id":"C7ba68e1f-ff88-42d0-8b47-3dbf32f70bd9",
																		},
																		"components":[
																			{
																				"type":"e-text",
																				"name":"Text",
																				"content":"Header",
																				"attributes":{
																					"id":"C50faeae9-e036-4db2-8fdf-1d8744eaee7d",
																				}
																			}
																		],
																		"custom-name":"Title"
																	}
																],
																"custom-name":"Main Card"
															},
															{
																"type":"div",
																"name":"Primary Button",
																"classes":[
																	"primary-cta"
																],
																"attributes":{
																	"id":"Cce36cb3f-0529-4beb-a71c-5b8fbaee2ef5",
																	"asset-id":""
																},
																"components":[
																	{
																		"type":"e-text",
																		"name":"Label",
																		"content":"Select",
																		"attributes":{
																			"id":"Cd5b771cd-09c1-4adc-a6ca-4ae4e0dc359b",
																		}
																	}
																],
																"custom-name":"Select Button"
															}
														],
														"custom-name":"Gallery Card 2"
													},
													{
														"type":"div",
														"attributes":{
															"id":"C59b5e03e-592b-479b-9156-d7af61a011be-3",
															"data-action":""
														},
														"components":[
															{
																"type":"div",
																"attributes":{
																	"id":"C59b5e03e-592b-479b-9156-d7af61a011be",
																	"data-action":""
																},
																"components":[
																	{
																		"type":"image",
																		"name":"Image",
																		"resizable":{
																			"ratioDefault":1
																		},
																		"attributes":{
																			"id":"Cf62ffc17-27ba-4a8d-afe3-4cab3602b6ae",
																			"asset-id":"",
																			"src":embeddedImagesBase64.imagePlaceholder,
																		}
																	},
																	{
																		"type":"div",
																		"name":"Background",
																		"attributes":{
																			"id":"C7f9f2d63-f8b6-4c17-9dd1-96689bfbbd86",
																		},
																		"components":[
																			{
																				"type":"e-text",
																				"name":"Text",
																				"content":"Header",
																				"attributes":{
																					"id":"C6fbe0bdf-9890-4da7-ba6f-fc87c3fb8a19",
																				}
																			}
																		],
																		"custom-name":"Title"
																	}
																],
																"custom-name":"Main Card"
															},
															{
																"type":"div",
																"name":"Primary Button",
																"classes":[
																	"primary-cta"
																],
																"attributes":{
																	"id":"C8186b8b5-20c1-48ff-9f26-20da7c3a4834",
																	"asset-id":""
																},
																"components":[
																	{
																		"type":"e-text",
																		"name":"Label",
																		"content":"Select",
																		"attributes":{
																			"id":"C6d9b6d57-9e3b-4b18-86f1-a4472fe54fb9",
																		}
																	}
																],
																"custom-name":"Select Button"
															}
														],
														"custom-name":"Gallery Card 3",
														"__prev-display":"flex"
													}
												],
												"custom-name":"Cards"
											}
										],
										"__prev-display":"flex",
										"custom-name":"Cards and Description"
									},
									{
										"type":"div",
										"name":"Home Button",
										"classes":[
											"secondary-icon-cta"
										],
										"attributes":{
											"id":"C777db716-dc93-4ae3-8599-3073f29fd221",
											"data-action":""
										},
										"components":[
											{
												"type":"image",
												"name":"Icon",
												"resizable":{
													"ratioDefault":1
												},
												"attributes":{
													"id":"C4ea1aa44-50fd-4bcc-8856-e6e4a4b7d2ce",
													"asset-id":"",
													"src":embeddedImagesBase64.home,
													"data-action":""
												}
											}
										]
									}
								],
								"custom-name":"Template Container"
							}
						],
						"custom-name":"Image Gallery"
					},
					"id":"n1iHnYSOpGPYdB6N"
				}
			],
			"type":"main",
			"id":"kOCGgDvnkDAuSz8T"
		}
	]
};

export default GjsTemplateImageMenu;